import React, { Component } from "react";
import httpService from "../../services/httpService";
import authService from "../../services/authService";
import config from "../../config.json";
import { Editor } from "@tinymce/tinymce-react";

class Praxe extends React.Component {
  state = { loaded: false, praxe: [], locked: false, novyZaznam: {} };
  componentDidMount = () => {
    this.nahrajPraxi();
  };

  timer = false;

  nahrajPraxi = async () => {
    const praxe = await httpService.post(
      config.apiEndpoint + "praxe/praxe.php"
    );
    this.setState({
      locked: praxe.data.locked,
      praxe: praxe.data.praxe,
      uvod: praxe.data.uvod,
      loaded: true,
      novyZaznam: {},
    });
  };

  zmenaNovy = (attr, val) => {
    let { novyZaznam } = this.state;
    novyZaznam[attr] = val;
    this.setState({ novyZaznam });
  };

  novyZaznam = async () => {
    const { novyZaznam } = this.state;
    await httpService.post(config.apiEndpoint + "praxe/novaPraxe.php", {
      novyZaznam,
    });
    this.nahrajPraxi();
  };

  zmenaPraxe = async (praxe_id, attr, val, save) => {
    let { praxe } = this.state;
    const index = praxe.findIndex((p) => p.praxe_id === praxe_id);
    praxe[index][attr] = val;
    this.setState({ praxe });
    if (save) {
      await httpService.post(config.apiEndpoint + "praxe/zmenaPraxe.php", {
        praxe_id,
        attr,
        val,
      });
      this.nahrajPraxi();
    }
  };

  delPraxe = async (praxe_id, confirmed) => {
    if (confirmed) {
      await httpService.post(config.apiEndpoint + "praxe/delPraxe.php", {
        praxe_id,
      });
      this.nahrajPraxi();
    } else {
      if (window.confirm("Skutečně smazat?")) {
        this.delPraxe(praxe_id, true);
      }
    }
  };

  lockPraxe = async () => {
    this.setState({ locked: true });
    await httpService.post(config.apiEndpoint + "praxe/lockPraxe.php");
    this.nahrajPraxi();
  };

  upravitUvodniText = (uvod) => {
    this.setState({ uvod });
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      httpService.post(config.apiEndpoint + "praxe/upravUvod.php", { uvod });
    }, 1000);
  };

  render() {
    const { loaded, praxe, locked, novyZaznam, uvod } = this.state;
    const user = authService.getCurrentUser();
    return (
      <div>
        {loaded ? (
          <React.Fragment>
            {user.admin === "1" ? (
              <Editor
                key={"uvod_editor"}
                apiKey={config.tinyMCEAPIkey}
                init={{
                  plugins: "link image code",
                  height: 400,
                }}
                name="uvod"
                id="uvod"
                value={uvod}
                outputFormat="html"
                onEditorChange={(text) => this.upravitUvodniText(text)}
              />
            ) : (
              <div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: uvod,
                  }}
                />
              </div>
            )}
            {!locked && praxe && praxe.length > 0 && (
              <div className="text-center" style={{ padding: "20px" }}>
                <button className="btn btn-primary" onClick={this.lockPraxe}>
                  Mám zadané všechny praxe, odevzdat výpis na personální...
                </button>
              </div>
            )}
            <table className="table primary-table">
              <thead>
                <tr>
                  <th>Zaměstnavatel</th>
                  <th>Pozice/Profese</th>
                  <th>Datum od</th>
                  <th>Datum do</th>
                  <th>Délka praxe</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {!locked && (
                  <tr>
                    <td>
                      <small>Nový záznam</small>
                      <input
                        type="text"
                        value={novyZaznam.zamestnavatel}
                        name="zamestnavatel"
                        className="form-control"
                        onChange={(e) =>
                          this.zmenaNovy(e.target.name, e.target.value)
                        }
                      />
                      <div>
                        <a
                          href="javascript:;"
                          onClick={() =>
                            this.zmenaNovy(
                              "zamestnavatel",
                              "Slatinné lázně Třeboň s.r.o."
                            )
                          }
                        >
                          Vyplnit "Slatinné lázně"
                        </a>
                      </div>
                    </td>
                    <td>
                      <small>&nbsp;</small>
                      <input
                        type="text"
                        value={novyZaznam.pozice}
                        name="pozice"
                        className="form-control"
                        onChange={(e) =>
                          this.zmenaNovy(e.target.name, e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <small>&nbsp;</small>
                      <input
                        type="date"
                        value={novyZaznam.datum_od}
                        name="datum_od"
                        className="form-control"
                        onChange={(e) =>
                          this.zmenaNovy(e.target.name, e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <small>Pokud trvá, nevyplňujte</small>
                      <input
                        type="date"
                        value={novyZaznam.datum_do}
                        name="datum_do"
                        className="form-control"
                        onChange={(e) =>
                          this.zmenaNovy(e.target.name, e.target.value)
                        }
                      />
                    </td>
                    <td className="text-center" colSpan={2}>
                      <button
                        className="btn btn-primary"
                        style={{ marginTop: "25px" }}
                        onClick={this.novyZaznam}
                        disabled={
                          !(
                            novyZaznam.zamestnavatel &&
                            novyZaznam.zamestnavatel !== "" &&
                            novyZaznam.datum_od &&
                            novyZaznam.datum_od !== ""
                          )
                        }
                      >
                        Uložit nový záznam
                      </button>
                    </td>
                  </tr>
                )}
                {praxe &&
                  praxe.length > 0 &&
                  praxe.map((p) => (
                    <React.Fragment key={p.praxe_id}>
                      <tr>
                        <td style={{ borderTopWidth: "3px" }}>
                          {locked ? (
                            p.zamestnavatel
                          ) : (
                            <React.Fragment>
                              <input
                                type="text"
                                name="zamestnavatel"
                                value={p.zamestnavatel}
                                className="form-control"
                                onChange={(e) =>
                                  this.zmenaPraxe(
                                    p.praxe_id,
                                    e.target.name,
                                    e.target.value,
                                    false
                                  )
                                }
                                onBlur={(e) =>
                                  this.zmenaPraxe(
                                    p.praxe_id,
                                    e.target.name,
                                    e.target.value,
                                    true
                                  )
                                }
                              />
                              {p.zamestnavatel !==
                                "Slatinné lázně Třeboň s.r.o." && (
                                <div>
                                  <a
                                    href="javascript:;"
                                    onClick={() =>
                                      this.zmenaPraxe(
                                        p.praxe_id,
                                        "zamestnavatel",
                                        "Slatinné lázně Třeboň s.r.o.",
                                        true
                                      )
                                    }
                                  >
                                    Vyplnit "Slatinné lázně"
                                  </a>
                                </div>
                              )}
                            </React.Fragment>
                          )}
                        </td>
                        <td style={{ borderTopWidth: "3px" }}>
                          {locked ? (
                            p.pozice
                          ) : (
                            <input
                              type="text"
                              name="pozice"
                              value={p.pozice}
                              className="form-control"
                              onChange={(e) =>
                                this.zmenaPraxe(
                                  p.praxe_id,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.zmenaPraxe(
                                  p.praxe_id,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          )}
                        </td>
                        <td style={{ borderTopWidth: "3px" }}>
                          {locked ? (
                            p.datum_od
                          ) : (
                            <input
                              type="date"
                              name="datum_od"
                              value={p.datum_od}
                              className="form-control"
                              onChange={(e) =>
                                this.zmenaPraxe(
                                  p.praxe_id,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.zmenaPraxe(
                                  p.praxe_id,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          )}
                        </td>
                        <td style={{ borderTopWidth: "3px" }}>
                          {locked ? (
                            p.datum_do
                          ) : (
                            <React.Fragment>
                              <input
                                type="date"
                                name="datum_do"
                                value={p.datum_do}
                                className="form-control"
                                onChange={(e) =>
                                  this.zmenaPraxe(
                                    p.praxe_id,
                                    e.target.name,
                                    e.target.value,
                                    false
                                  )
                                }
                                onBlur={(e) =>
                                  this.zmenaPraxe(
                                    p.praxe_id,
                                    e.target.name,
                                    e.target.value,
                                    true
                                  )
                                }
                              />
                              {p.datum_do && p.datum_do !== "0000-00-00" && (
                                <div>
                                  <a
                                    href="javascript:;"
                                    onClick={(e) =>
                                      this.zmenaPraxe(
                                        p.praxe_id,
                                        "datum_do",
                                        "0000-00-00",
                                        true
                                      )
                                    }
                                  >
                                    Stále probíhá
                                  </a>
                                </div>
                              )}
                            </React.Fragment>
                          )}
                        </td>
                        <td style={{ borderTopWidth: "3px" }}>
                          {"Roky: " + Math.floor(p.delka / 365)}
                          <br />
                          {"Dny: " + (p.delka % 365)}
                        </td>
                        <td style={{ borderTopWidth: "3px" }}>
                          {!locked && (
                            <button
                              className="btn btn-danger"
                              onClick={() => this.delPraxe(p.praxe_id)}
                            >
                              Del
                            </button>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={6}>
                          <small>Poznámka</small>
                          {locked ? (
                            <div>{p.poznamka}</div>
                          ) : (
                            <input
                              type="text"
                              name="poznamka"
                              value={p.poznamka}
                              className="form-control"
                              onChange={(e) =>
                                this.zmenaPraxe(
                                  p.praxe_id,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.zmenaPraxe(
                                  p.praxe_id,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </React.Fragment>
        ) : (
          "Loading..."
        )}
      </div>
    );
  }
}

export default Praxe;
